import React from 'react';
import { Checkbox as BaseCheckbox } from "../../../shared/components";
import { DocumentedComponent } from '../../../shared/components/DocumentedComponent';
import { useAppSelector } from "../../../store";
import { useAppActions } from "../../../shared/hooks";

interface Props {
    name: string;
}

function Checkbox(props: Props) {
    const { name, ...rest } = props;
    const parameterValues = useAppSelector(state => state.storyline.parameterValues);
    const { updateParameterValue } = useAppActions();
    const [value, setValue] = React.useState(parameterValues.get(name) as boolean || false);

    const handleChange = (event: any) => {
        updateParameterValue(name, event.target.checked);
        setValue(event.target.checked);
    };

    React.useEffect(() => {

        if (parameterValues.has(name)) {
            const newValue = parameterValues.get(name) as boolean;
            if (newValue !== value) {
                setValue(newValue);
            }
        }

    }, [parameterValues]);

    return (
        <BaseCheckbox
            name={name}
            {...rest}
            checked={value}
            onChange={handleChange}
            slotProps={{
                input: {
                    'aria-label': 'primary checkbox'
                }
            }}
        />
    );
}

(Checkbox as DocumentedComponent).metadata = {
    description: "The `Checkbox` component allows the user to select a `true` or `false` value for a storyline variable.",
    isSelfClosing: true,
    attributes: [
        { name: `name`, type: `string`, description: "The name of the variable that the selected value(s) will be read from and persisted to. The underlying component's `data-testid` attribute will be set to this value. This is useful for targeting the element via Playwright, Puppeteer or similar UI testing tools. Can be overridden via an explicit `data-testid` value." },
        { name: `size`, type: `string`, options: ["small", "medium", "large"], description: `The (optional) size of the Checkbox.  Defaults to \`"medium"\`.` }
    ]
};

export default Checkbox;
